var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37.1044,
    height: 35,
    rx: 8,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1414 21.5212L24.3073 24.4219C24.246 24.4849 24.1717 24.5352 24.0892 24.5696C24.0066 24.604 23.9175 24.6218 23.8275 24.6218H10.3928C10.3287 24.6218 10.266 24.604 10.2124 24.5704C10.1588 24.5369 10.1166 24.4892 10.091 24.4332C10.0653 24.3771 10.0574 24.3151 10.0681 24.2548C10.0788 24.1945 10.1077 24.1385 10.1513 24.0936L12.9821 21.193C13.0435 21.13 13.1176 21.0797 13.2002 21.0453C13.2827 21.0109 13.3719 20.993 13.462 20.993H26.8966C26.9612 20.9917 27.025 21.0087 27.0795 21.0418C27.134 21.0751 27.1772 21.1228 27.2032 21.1793C27.2295 21.2358 27.2375 21.2984 27.2265 21.3592C27.2154 21.42 27.1858 21.4764 27.1414 21.5212ZM24.3073 15.6787C24.2458 15.616 24.1714 15.5659 24.089 15.5315C24.0065 15.4971 23.9175 15.4792 23.8275 15.4787H10.3928C10.3287 15.4787 10.266 15.4966 10.2124 15.5301C10.1588 15.5636 10.1166 15.6113 10.091 15.6674C10.0653 15.7234 10.0574 15.7854 10.0681 15.8457C10.0788 15.906 10.1077 15.9621 10.1513 16.0069L12.9821 18.9091C13.0437 18.9718 13.1179 19.0219 13.2004 19.0563C13.283 19.0907 13.3719 19.1087 13.462 19.1091H26.8966C26.9606 19.1087 27.023 19.0907 27.0765 19.057C27.1299 19.0234 27.1717 18.9757 27.1972 18.9197C27.2226 18.8637 27.2305 18.8018 27.2196 18.7417C27.2088 18.6815 27.1801 18.6256 27.1366 18.5809L24.3073 15.6787ZM10.3928 13.5948H23.8275C23.9175 13.5947 24.0066 13.5769 24.0892 13.5424C24.1717 13.508 24.246 13.4578 24.3073 13.3948L27.1414 10.4941C27.1858 10.4493 27.2154 10.3929 27.2265 10.3321C27.2375 10.2713 27.2295 10.2087 27.2032 10.1522C27.1772 10.0958 27.134 10.0479 27.0795 10.0148C27.025 9.98163 26.9612 9.96461 26.8966 9.96589H13.462C13.3719 9.96598 13.2827 9.98378 13.2002 10.0182C13.1176 10.0526 13.0435 10.1029 12.9821 10.1659L10.1513 13.0666C10.1077 13.1114 10.0788 13.1674 10.0681 13.2277C10.0574 13.2881 10.0653 13.35 10.091 13.4061C10.1166 13.4621 10.1588 13.5099 10.2124 13.5434C10.266 13.5769 10.3287 13.5947 10.3928 13.5948Z",
    fill: "url(#paint0_linear_1_3305)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3305",
    x1: 11.5123,
    y1: 24.9715,
    x2: 24.8705,
    y2: 9.19443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8752F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5497D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#43B4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#28E0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#19FB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmSol);
export default __webpack_public_path__ + "static/media/gmSOL.ee8a0e540ad741f49fd742b57fcd0ca9.svg";
export { ForwardRef as ReactComponent };